function memoryStorage(): Storage {
    const store = new Map<string, string>();
  
    return {
      get length() {
        return store.size;
      },
      clear() {
        store.clear();
      },
      key(n: number) {
        return Array.from(store.keys())[n] ?? null;
      },
      getItem(key: string) {
        return store.has(key) ? store.get(key)! : null;
      },
      setItem(key: string, value: string) {
        store.set(key, String(value));
      },
      removeItem(key: string) {
        store.delete(key);
      }
    } as Storage;
  }
  
  export function getSafeStorage(): Storage {
    try {
      const k = "__ls_test__";
      localStorage.setItem(k, "1");
      localStorage.removeItem(k);
      return localStorage;
    } catch {
      return memoryStorage();
    }
  }